import React, { useCallback, useState } from 'react'
import { SubscribeModal } from 'ppp'
import { gaEvent } from 'shared'
import { SubscribeButtonProps } from './types'

import newsletterIcon from './icon-newsletter.svg'

export const AbSubscribeButton = ({ project, url }: SubscribeButtonProps): JSX.Element => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_open_link__top')
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_close_link__top')
    setShow(false)
  }, [])

  return (
    <div className="mb-4">
      <div className="flex items-start">
        <img src={newsletterIcon} alt="" />
        <div className="flex flex-col ml-4">
          <p>
            {I18n.locale === 'de'
              ? 'Werde Fan und erhalte spannende Neuigkeiten von der Organisation'
              : 'Become a fan and receive news and updates from the organization'}
          </p>
          <a onClick={handleClick}>{I18n.locale === 'de' ? 'Mehr erfahren' : 'Learn more'}</a>
        </div>
      </div>

      <SubscribeModal show={show} project={project} url={url} onHide={onHide} />
    </div>
  )
}
